import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router";
import { isTokenExist } from "utils/cookies";
import useLoadInits from "hooks/useLoadInits";
import store from "store";
import PublicLayout from "../public";
import { useSelector } from "react-redux";
import { companiesSelector } from "appredux/selectors";
import usePreviousPathname from "hooks/usePreviousPathName";

const SelectCompanyLayout = () => {
  const navigate = useNavigate();
  const companies = useSelector(companiesSelector);
  const skipCheckEndpoint = true;
  const from = usePreviousPathname();

  useEffect(() => {
    if (isTokenExist()) {
      if (store.get("app.endpoint") && companies.length > 0) {
        navigate(from || "/", {
          replace: true,
        });
      }
    } else {
      navigate("/user/login", { replace: true });
    }
  }, [companies, navigate, from]);

  useLoadInits(skipCheckEndpoint, { useBootstrapEndpoint: true });

  return (
    <PublicLayout
      className="min-h-screen bg-gradient-to-r from-blue-900 to-primary"
      withFooter={false}
    >
      <Outlet />
    </PublicLayout>
  );
};

export default SelectCompanyLayout;
